import { createAction } from 'redux-actions';
import { instance } from "../../../config/interceptor";

export const cleanupAction = createAction('CLEANUP_AU_ASSIGN_SURVEYS');

export const cleanup = ()  => async (dispatch) => {
  dispatch(cleanupAction());
}

export const getAuditCampaignRequest = createAction('AU_ASSIGN_SURVEYS_GET_CAMPAIGN_REQUEST');
export const getAuditCampaignSuccess = createAction('AU_ASSIGN_SURVEYS_GET_CAMPAIGN_SUCCESS');
export const getAuditCampaignError = createAction('AU_ASSIGN_SURVEYS_GET_CAMPAIGN_ERROR');

export const getAuditCampaign = (id) => async (dispatch) => {
  try {
    dispatch(getAuditCampaignRequest());
    const resp = await instance.get(`/v1/ActivityCampaign/GetByActivityId/${id}`);
    
    dispatch(getAuditCampaignSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getAuditCampaignError(e.response.data.description));
    else
      dispatch(getAuditCampaignError(e.message));
  }
};

export const getSurveysRequest = createAction('AU_ASSIGN_SURVEYS_GET_SURVEYS_REQUEST');
export const getSurveysSuccess = createAction('AU_ASSIGN_SURVEYS_GET_SURVEYS_SUCCESS');
export const getSurveysError = createAction('AU_ASSIGN_SURVEYS_GET_SURVEYS_ERROR');

export const getSurveys = (data) => async (dispatch) => {
  try {
    dispatch(getSurveysRequest());
    const resp = await instance.post(`/v1/Survey/GetSurveysByIds`, data);

    dispatch(getSurveysSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getSurveysError(e.response.data.description));
    else
      dispatch(getSurveysError(e.message));
  }
};

export const getWorkflowRolesRequest = createAction('AU_ASSIGN_SURVEYS_GET_WORKFLOW_ROLES_REQUEST');
export const getWorkflowRolesSuccess = createAction('AU_ASSIGN_SURVEYS_GET_WORKFLOW_ROLES_SUCCESS');
export const getWorkflowRolesError = createAction('AU_ASSIGN_SURVEYS_GET_WORKFLOW_ROLES_ERROR');

export const getWorkflowRoles = (id) => async (dispatch) => {
  try {
    dispatch(getWorkflowRolesRequest());
    const resp = await instance.get(`/v1/Workflow/GetWorkflowRoles?ActivityTypeId=${id}`);
    
    if(resp.data.isSuccessed)
      dispatch(getWorkflowRolesSuccess(resp.data.data));
    else
      dispatch(getWorkflowRolesError(resp.data.error));
  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getWorkflowRolesError(e.response.data.description));
    else
      dispatch(getWorkflowRolesError(e.message));
  }
};

export const getRolesWithUsersRequest = createAction('AU_ASSIGN_SURVEYS_GET_USERS_WITH_ROLES_REQUEST');
export const getRolesWithUsersSuccess = createAction('AU_ASSIGN_SURVEYS_GET_USERS_WITH_ROLES_SUCCESS');
export const getRolesWithUsersError = createAction('AU_ASSIGN_SURVEYS_GET_USERS_WITH_ROLES_ERROR');

export const getRolesWithUsers = (roles) => async (dispatch) => {
  try {
    dispatch(getRolesWithUsersRequest());
    
    const resp = await instance.post(`/v1/UserAndRole/GetUsersByRoleIds`, { 
      roleIds: roles 
    });
    
    dispatch(getRolesWithUsersSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getRolesWithUsersError(e.response.data.description));
    else
      dispatch(getRolesWithUsersError(e.message));
  }
};

export const getAssetsRequest = createAction('AU_ASSIGN_SURVEYS_GET_LIST_REQUEST');
export const getAssetsSuccess = createAction('AU_ASSIGN_SURVEYS_GET_LIST_SUCCESS');
export const getAssetsError = createAction('AU_ASSIGN_SURVEYS_GET_LIST_ERROR');

export const getAssets = () => async (dispatch) => {
  try {
    dispatch(getAssetsRequest());
    const resp = await instance.get(`/v1/Stakeholder/GetTenantStakeholders`);
    
    dispatch(getAssetsSuccess(resp.data));

  } catch (e) {
    if(e.response && e.response.data && e.response.data.description)
      dispatch(getAssetsError(e.response.data.description));
    else
      dispatch(getAssetsError(e.message));
  }
}